var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',{attrs:{"hide-delimiters":"","interval":"5000","height":_vm.ch}})}
var staticRenderFns = []

export { render, staticRenderFns }